/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */
/* eslint-disable no-unused-vars */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useTrellisSmileys"];
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import CsatButton from './internal/CsatButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TRELLIS_SMILEYS_NEGATIVE_COLOR, resolveRespondentCssColor } from 'feedback-schema/constants/respondentTypeColorTokens';
import * as RespondentTypes from 'feedback-schema/constants/respondentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const path = 'M416 0Q303 0 206 57q-94 55-149 149Q0 303 0 416t57 210q55 94 149 150 97 56 210 56t210-56q94-56 149-150 57-97 57-210t-57-210q-55-94-149-149Q529 0 416 0zm139 298q23 0 39 16.5t16 39-16 39-39.5 16.5-40-16-16.5-39 16.5-39.5T554 298h1zm-278 0q23 0 39.5 16.5t16.5 39-16 38.5-38.5 16-38.5-16.5-16-38.5v-1q0-22 15.5-37.5T277 298zm-64 284q41-37 93-58.5T415 500h1q58 2 110 23t94 58v-1q7 9 7 20t-8 19h1q-8 9-19 9t-18-9q-34-29-77-46t-89-19h-1q-48 1-91.5 18T246 618q-7 7-17 7-4 0-8-1-15-6-17-21v-3q0-11 8-20l1 2z';
export default (_ref => {
  let {
      useTrellisSmileys = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trellisTheme = useTheme();
  return isCanvasTheme(trellisTheme) ? /*#__PURE__*/_jsx(CsatButton, Object.assign({
    color: trellisTheme.color['do-not-use-chart-red'],
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.negative"
    }),
    viewBox: "0 0 54 54"
  }, props, {
    children: /*#__PURE__*/_jsx("g", {
      id: "Setup---Choose-Survey---CSAT---Chat",
      transform: "translate(-878.000000, -762.000000)",
      fillRule: "nonzero",
      children: /*#__PURE__*/_jsx("g", {
        id: "chat-widget",
        transform: "translate(761.000000, 320.000000)",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Unhappy",
          transform: "translate(118.000000, 443.000000)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M26,0 C11.6405965,0 0,11.6405965 0,26 C0,40.3594035 11.6405965,52 26,52 C40.3594035,52 52,40.3594035 52,26 C51.9787869,11.6493924 40.3506076,0.0212130541 26,0 Z",
            id: "Path",
            stroke: "#33475C",
            strokeWidth: "2",
            fill: "#F3B1C9"
          }), /*#__PURE__*/_jsx("path", {
            d: "M35.0518519,18.1422222 C36.5085151,18.1422222 37.821746,19.019695 38.3791869,20.3654764 C38.9366278,21.7112578 38.6285003,23.2603192 37.5984838,24.2903357 C36.5684673,25.3203522 35.019406,25.6284796 33.6736246,25.0710387 C32.3278432,24.5135978 31.4503704,23.200367 31.4503704,21.7437037 C31.4503704,19.7546604 33.0628086,18.1422222 35.0518519,18.1422222 L35.0518519,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9481481,18.1422222 C18.4048114,18.1422222 19.7180423,19.019695 20.2754832,20.3654764 C20.8329241,21.7112578 20.5247966,23.2603192 19.4947801,24.2903357 C18.4647636,25.3203522 16.9157022,25.6284796 15.5699209,25.0710387 C14.2241395,24.5135978 13.3466667,23.200367 13.3466667,21.7437037 C13.3466667,19.7546604 14.9591048,18.1422222 16.9481481,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("path", {
            d: "M38.922963,33.9733333 C35.2593261,36.9485102 30.7175935,38.6338923 26,38.7688889 C21.2879446,38.6354088 16.7518509,36.9496069 13.0962963,33.9733333 C12.4049176,33.3723657 12.331625,32.324712 12.9325926,31.6333334 C13.5335603,30.9419547 14.5812139,30.868662 15.2725926,31.4696296 C18.3301006,33.911425 22.0898935,35.308691 26,35.4562963 C29.9178391,35.318206 33.686646,33.9201002 36.7466667,31.4696296 C37.1939103,31.0808717 37.8145803,30.9602462 38.3748763,31.1531916 C38.9351723,31.3461369 39.349972,31.8233402 39.4630244,32.4050434 C39.5760769,32.9867467 39.3702066,33.5845755 38.922963,33.9733333 L38.922963,33.9733333 Z",
            id: "Path",
            fill: "#33475C",
            transform: "translate(26.009636, 34.915835) rotate(180.000000) translate(-26.009636, -34.915835) "
          })]
        })
      })
    })
  })) : /*#__PURE__*/_jsxs(CsatButton, Object.assign({
    color: resolveRespondentCssColor(RespondentTypes.DETRACTOR, useTrellisSmileys, trellisTheme),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.negative"
    }),
    viewBox: "0 0 80 80"
  }, props, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_604_1082)",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "80",
        height: "80",
        rx: "40",
        fill: useTrellisSmileys ? TRELLIS_SMILEYS_NEGATIVE_COLOR : '#FF9FCC'
      }), /*#__PURE__*/_jsx("path", {
        d: "M52.8883 39.5556C55.9964 39.5556 58.5179 37.0342 58.5179 33.926C58.5179 30.8179 55.9964 28.2964 52.8883 28.2964C49.7801 28.2964 47.2586 30.8179 47.2586 33.926C47.2586 37.0342 49.7801 39.5556 52.8883 39.5556Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        d: "M32.7401 33.8668C32.7401 30.7586 30.2186 28.2371 27.1105 28.2371C24.0023 28.2371 21.4809 30.7586 21.4809 33.8668C21.4809 36.9749 24.0023 39.4964 27.1105 39.4964C30.2186 39.4964 32.7401 36.9749 32.7401 33.8668Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        d: "M39.9461 48.0593C32.512 48.3171 25.7238 51.1201 20.4735 55.5853L20.4764 55.5823C19.9312 56.1186 19.5935 56.8653 19.5935 57.6919C19.5935 58.3616 19.8127 58.9749 20.1801 59.4638L20.1831 59.4697C20.6512 60.0416 21.3594 60.406 22.1564 60.406C22.8231 60.406 23.4305 60.1512 23.8838 59.7334L23.8394 59.769C28.2483 56.1068 33.8335 53.8134 40.0023 53.5408L40.0586 53.5438C46.1594 53.8075 51.7357 56.0919 56.0912 59.7038L56.0883 59.7008C56.5416 60.1216 57.149 60.3764 57.8157 60.3764C58.6098 60.3764 59.3209 60.0119 59.792 59.4371L59.789 59.4401C60.1949 58.9542 60.4409 58.329 60.4409 57.6475C60.4409 56.8301 60.0886 56.0956 59.5261 55.5831C59.5364 55.5919 59.5467 55.6007 59.557 55.6095L59.5261 55.5831C59.5259 55.5828 59.5264 55.5833 59.5261 55.5831C54.2519 51.0761 47.4735 48.281 39.9994 48.0564L39.9461 48.0593Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 40C0 62.0919 17.9081 80 40 80H40.003C62.0859 79.9822 79.9822 62.0859 80 40C80 17.9081 62.0919 0 40 0C17.9081 0 0 17.9081 0 40ZM5.71852 40C5.71852 21.0667 21.0667 5.71852 40 5.71852H40.003C58.9274 5.7363 74.2637 21.0726 74.2815 40C74.2815 58.9333 58.9333 74.2815 40 74.2815C21.0667 74.2815 5.71852 58.9333 5.71852 40Z",
        fill: "#141414"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_604_1082",
        children: /*#__PURE__*/_jsx("rect", {
          width: "80",
          height: "80",
          rx: "40",
          fill: "white"
        })
      })
    })]
  }));
});